// extracted by mini-css-extract-plugin
export default {"header":"header_header__lOwdN","headerNav":"header_headerNav__hir6Y","headerNavLogo":"header_headerNavLogo__WM3Kn"};